import React, { useEffect, useRef, useState } from "react";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import SectionTitle from "../components/shared/SectionTitle";
import { useForm } from "react-hook-form";
import Input from "../components/shared/Form/Input";
import { FileUpload } from "primereact/fileupload";
import { getItemStorage } from "../Localstorage/useLocalStorage";
import { BiPlus } from "react-icons/bi";
import { getData, postData } from "../services/API";
import CircleLoading from "../components/shared/CircleLoading";
import { Toast } from "primereact/toast";
import Footer from "../components/Footer/Footer";
import { getWindowSize, toFarsiNumber } from "../helper/helper";
import Loading from "../components/shared/Loading";
import { Swiper, SwiperSlide } from "swiper/react";

const JoinRequest = () => {
  const { setValue, getValues, register } = useForm();
  const [image, setImage] = useState("");
  const [uploading, setUploading] = useState("");
  const [uploading2, setUploading2] = useState("");
  const [doc, setDoc] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [response, setResponse] = useState(false);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [chosen, setChosen] = useState([]);
  const [chosenLoading, setChosenLoading] = useState(true);
  const [selectedMember, setSelectedMember] = useState({});

  const success = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    getData("/faculty-list-mp", {})
      .then((res) => {
        setChosen(res.data);
        setChosenLoading(false);
      })
      .catch((err) => {
        setChosenLoading(false);
      });

    const handleWindowResize = () => {
      setWindowSize(getWindowSize());
    };

    window.addEventListener("resize", handleWindowResize);
  }, []);

  const submitHandler = () => {
    setLoading(true);
    setErrMsg([]);

    postData("/faculty", { ...getValues(), docs: doc, pic_url: image })
      .then((res) => {
        setLoading(false);
        setResponse(true);
        success.current.show({
          severity: "success",
          summary: "با موفقیت ایجاد شد",
          detail: "درخواست شما با موفقیت ثبت شد",
          life: 3000,
        });
      })
      .catch((err) => {
        success.current.show({
          severity: "error",
          summary: "خطا هنگام ثبت درخواست",
          detail: err.response.data.message,
          life: 3000,
        });

        setLoading(false);
        setErrMsg(err.response.data);
      });
  };

  const beforeUpload = (e, type) => {
    if (type === "image") {
      setUploading(true);
    } else {
      setUploading2(true);
    }

    let token = getItemStorage("token");
    e.xhr.setRequestHeader("Authorization", `Bearer ${token}`);
  };

  const uploadThumbnailHandler = (e) => {
    setImage(JSON.parse(e.xhr.response).image);
    setUploading(false);

    success.current.show({
      severity: "success",
      summary: "با موفقیت ایجاد شد",
      detail: "تصویر شما با موفقیت بارگذاری شد",
      life: 3000,
    });
  };

  const uploadErrorHandler = (e) => {
    const errorImg = JSON.parse(e.xhr.response);
  };

  const uploadDocumentHandler = (e) => {
    success.current.show({
      severity: "success",
      summary: "با موفقیت ایجاد شد",
      detail: "مدارک شما با موفقیت بارگذاری شد",
      life: 3000,
    });

    setUploading2(false);
    setDoc(JSON.parse(e.xhr.response).image);
  };

  const uploadIcon = (
    <div className="flex items-center justify-center gap-1 font-[YekanBakh] px-1">
      <BiPlus className="text-xl text-white" />
      <span>
        {uploading
          ? "درحال بارگذاری..."
          : image
          ? "تغییر تصویر"
          : "بارگذاری تصویر"}
      </span>
    </div>
  );

  const uploadIcon2 = (
    <div className="flex items-center justify-center gap-1 font-[YekanBakh] px-1">
      <BiPlus className="text-xl text-white" />
      <span>
        {uploading2
          ? "درحال بارگذاری..."
          : image
          ? "تغییر مدارک"
          : "بارگذاری مدارک"}
      </span>
    </div>
  );

  let chosenPerview;
  if (windowSize.innerWidth < 720) {
    chosenPerview = 3;
  } else if (windowSize.innerWidth < 885) {
    chosenPerview = 6;
  } else if (windowSize.innerWidth >= 640 && windowSize.innerWidth <= 1230) {
    chosenPerview = 8;
  } else {
    chosenPerview = 10;
  }

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />
      <Toast ref={success} />

      <div
        className={`${
          selectedMember?.id ? "opacity-100 visible" : "opacity-0 invisible"
        } transition-all duration-300 w-full h-full fixed bg-black bg-opacity-40 right-0 z-[99999999] top-0`}
      ></div>
      <div
        className={`${
          selectedMember?.id
            ? "opacity-100 visible scale-100"
            : "opacity-0 invisible scale-75"
        } transition-all duration-300 lg:max-w-[700px] w-full h-fit rounded-2xl p-4 absolute -translate-y-2/4  z-[999999909] -translate-x-2/4 top-2/4 left-2/4`}
      >
        <div className="bg-[#222] flex flex-col gap-3 p-3 rounded-xl relative">
          <div className="flex items-center gap-2">
            <img
              src={`https://api.myunibest.ir/${selectedMember.img}`}
              className="rounded-full w-20 h-20 object-cover object-center border-[3px] border-[#151515]"
              alt=""
            />

            <div className="flex flex-col gap-1">
              <h2 className="font-black text-lg text-gray-200">
                {selectedMember?.name}
              </h2>
              <span className="text-sm text-gray-400">
                عضویت:{" "}
                {selectedMember?.created_at &&
                  new Intl.DateTimeFormat("fa-IR", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  }).format(new Date(selectedMember?.created_at))}
              </span>
            </div>
          </div>

          <button
            onClick={() => setSelectedMember({})}
            className="rounded-xl absolute top-3 left-3 flex justify-center items-center size-10 text-sm bg-gradient-to-tl text-white from-red-600 to-red-400"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18 18 6M6 6l12 12"
              />
            </svg>
          </button>

          <p className="text-sm text-gray-300">{selectedMember?.des}</p>
        </div>
      </div>

      <div className="w-full xl:max-w-[1300px] flex flex-col items-center mt-4 gap-4 px-3 2xl:px-0">
        {chosen.length > 0 && (
          <div className="w-full flex flex-col gap-4">
            <SectionTitle
              className={"mb-3"}
              title1={"اعضای هیئت علمی"}
              title2={"یونی بست"}
            />

            <Swiper
              className="mySwiper lg:col-span-6 header-slider"
              pagination={{
                dynamicBullets: true,
              }}
              slidesPerView={chosenPerview}
            >
              {chosen.map((member, i) => (
                <SwiperSlide className="">
                  <button
                    onClick={() => setSelectedMember(member)}
                    className="flex flex-col items-center gap-3"
                  >
                    <div className="story-item active:scale-90 transition-all duration-300 w-[90px] p-[2px] h-[90px] rounded-full">
                      <img
                        src={`https://api.myunibest.ir/${member.img}`}
                        className="rounded-full w-full h-full object-cover object-center border-[3px] border-[#151515]"
                        alt=""
                      />
                    </div>

                    <span className="text-sm text-gray-300">{member.name}</span>
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        <SectionTitle
          className={"mb-3"}
          title1={"عضویت هیئت علمی"}
          title2={"یونی بست"}
        />

        {chosenLoading ? (
          <Loading />
        ) : response ? (
          <div className="w-full flex flex-col items-center bg-[#222] rounded-xl gap-4 p-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-32 h-32 stroke-green-600"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>

            <span className="text-2xl text-green-600 font-black">
              با موفقیت انجام شد
            </span>

            <p className="text-gray-400">
              درخواست شما با موفقیت در یونی بست ثبت شد بزودی کارشناسان ما با شما
              تماس میگیرند.
            </p>
          </div>
        ) : (
          <div className="w-full flex flex-col bg-[#222] rounded-xl gap-4 p-4">
            <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-4">
              <Input
                element={"input"}
                label={"نام"}
                placeHolder={"نام خود را وارد کنید"}
                register={{ ...register("name") }}
                error={errMsg && errMsg["name"]}
                errorText={"نام اجباری است"}
              />
              <Input
                element={"input"}
                label={"نام خانوادگی"}
                placeHolder={"نام خانوادگی خود را وارد کنید"}
                register={{ ...register("family_name") }}
                error={errMsg && errMsg["family_name"]}
                errorText={"نام خانوادگی اجباری است"}
              />
              <Input
                element={"input"}
                label={"کد ملی"}
                placeHolder={"کد ملی خود را وارد کنید"}
                register={{ ...register("melli_code") }}
                error={errMsg && errMsg["melli_code"]}
                errorText={"کد ملی اجباری است"}
              />
              <Input
                element={"input"}
                label={"شماره تلفن"}
                placeHolder={"شماره تلفن خود را وارد کنید"}
                register={{ ...register("phone_number") }}
                error={errMsg && errMsg["phone_number"]}
                errorText={"شماره تلفن اجباری است"}
              />
              <Input
                element={"input"}
                wrapperClass={"lg:col-span-2"}
                label={"آدرس"}
                placeHolder={"آدرس خود را وارد کنید"}
                register={{ ...register("address") }}
                error={errMsg && errMsg["address"]}
                errorText={"آدرس اجباری است"}
              />
              <Input
                label={"سوابق تحصیلی"}
                className="!h-36"
                placeHolder={"سوابق تحصیلی خود را وارد کنید"}
                register={{ ...register("edu_history") }}
                error={errMsg && errMsg["edu_history"]}
              />
              <Input
                label={"سوابق کاری"}
                className="!h-36"
                placeHolder={"سوابق کاری خود را وارد کنید"}
                register={{ ...register("work_history") }}
                error={errMsg && errMsg["work_history"]}
              />
              <Input
                label={"سوابق تدریس"}
                className="!h-36"
                placeHolder={"سوابق تدریس خود را وارد کنید"}
                register={{ ...register("teach_history") }}
                error={errMsg && errMsg["teach_history"]}
              />
              <Input
                label={"حوزه و دروس تدریس"}
                className="!h-36"
                placeHolder={"حوزه و دروس تدریس خود را وارد کنید"}
                register={{ ...register("teach_department") }}
                error={errMsg && errMsg["teach_department"]}
              />
              <Input
                label={"سوابق و تاثیرگذاری کارآفرینی"}
                className="!h-36"
                placeHolder={"سوابق خود را وارد کنید"}
                register={{ ...register("startup_history") }}
                error={errMsg && errMsg["startup_history"]}
              />
              <Input
                label={"سوابق مشاوره"}
                className="!h-36"
                placeHolder={"سوابق مشاوره خود را وارد کنید"}
                register={{ ...register("cons_history") }}
                error={errMsg && errMsg["cons_history"]}
              />
              <Input
                label={"سوابق برگذاری همایش و موضوع همایش"}
                className="!h-36"
                placeHolder={"سوابق خود را وارد کنید"}
                register={{ ...register("event_history") }}
                error={errMsg && errMsg["event_history"]}
              />
              <Input
                wrapperClass={"lg:col-span-2"}
                className="!h-36"
                label={"سایر موارد قابل ذکر"}
                register={{ ...register("other") }}
                error={errMsg && errMsg["other"]}
              />
            </div>

            <div className="w-full flex justify-center gap-6">
              <div className="flex flex-col items-center gap-2">
                <FileUpload
                  name="pic_url"
                  url="https://api.myunibest.ir/api/faculty-upload-pic"
                  onUpload={(e) => uploadThumbnailHandler(e)}
                  accept="image/*"
                  onBeforeSend={(e) => beforeUpload(e, "image")}
                  onError={uploadErrorHandler}
                  mode="basic"
                  auto
                  maxFileSize={1000000}
                  className="!font-[YekanBakh] !w-40 self-center about-upload ticket-file-upload"
                  chooseLabel={uploadIcon}
                  multiple
                  emptyTemplate={
                    <div>
                      <p className="m-0 text-sm">
                        جهت بارگذاری فایل خود را بکشید و اینجا رها کنید.
                      </p>
                    </div>
                  }
                />

                {image && (
                  <img
                    src={`https://api.myunibest.ir/${image}`}
                    className="w-40 rounded-xl"
                    alt=""
                  />
                )}

                {errMsg && errMsg["pic_url"] && (
                  <span className="text-red-600 text-sm">
                    {errMsg["pic_url"]}
                  </span>
                )}
              </div>

              {/* <input
              type="file"
              multiple
              placeholder="uplaod"
              onChange={customDocUploadHandler}
            /> */}

              <div className="flex flex-col items-center gap-2">
                <FileUpload
                  name="files[]"
                  url="https://api.myunibest.ir/api/faculty-upload-doc"
                  onUpload={(e) => uploadDocumentHandler(e)}
                  onBeforeSend={(e) => beforeUpload(e)}
                  onError={uploadErrorHandler}
                  mode="basic"
                  auto
                  maxFileSize={1000000}
                  className="!font-[YekanBakh] !w-40 self-center about-upload ticket-file-upload"
                  chooseLabel={uploadIcon2}
                  multiple
                  emptyTemplate={
                    <div>
                      <p className="m-0 text-sm">
                        جهت بارگذاری فایل خود را بکشید و اینجا رها کنید.
                      </p>
                    </div>
                  }
                />

                {doc.length > 0 && (
                  <span className="text-sm text-green-600">
                    {toFarsiNumber(doc.length)} مدرک بارگذاری شد
                  </span>
                )}

                {errMsg && errMsg["docs"] && (
                  <span className="text-red-600 text-sm">{errMsg["docs"]}</span>
                )}
              </div>
            </div>

            <button
              onClick={submitHandler}
              className="text-white self-center w-40 h-10 flex items-center justify-center bg-green-600 rounded-xl"
            >
              {loading ? <CircleLoading /> : "ثبت درخواست"}
            </button>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default JoinRequest;
